import React from "react";

/**
 * Quick fire questions component
 * @param user user object
 * @param { string } department String of flaunt department name
 * @returns Returns a quick fire questions component
 */
const QuickFireQuestions = ({ user, department }) => {
    return(
        <div className="author-quick-fire">
            {user?.user_department_information?.userQuickFireQuestionRepeater && user?.user_department_information?.userQuickFireQuestionRepeater.length > 0 && (
                <h2 className="h1">quick fire questions</h2>
            )}
            <div className="author-quick-fire-question">
                { user?.user_department_information?.userQuickFireQuestionRepeater && user?.user_department_information?.userQuickFireQuestionRepeater.map(( user, index ) => {
                    return(
                        <div key={`author-quick-fire-${index}`} className={`service-background-light-${department} author-quick-fire-question-single`}>
                            <h3 className={`service-colour-${department}`} dangerouslySetInnerHTML={{ __html: user.userQuickFireQuestionRepeaterSubheader }} />
                            <div dangerouslySetInnerHTML={{ __html: user.userQuickFireQuestionRepeaterContent }} />
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default QuickFireQuestions;